/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegenerateChildAdolescentServiceRequestDto } from '../../models/regenerate-child-adolescent-service-request-dto';
import { RegenerationTextResultDto } from '../../models/regeneration-text-result-dto';

export interface DocumentAiV2ControllerRegenerateChildAdolescentServiceRequest$Params {
      body: RegenerateChildAdolescentServiceRequestDto
}

export function documentAiV2ControllerRegenerateChildAdolescentServiceRequest(http: HttpClient, rootUrl: string, params: DocumentAiV2ControllerRegenerateChildAdolescentServiceRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiV2ControllerRegenerateChildAdolescentServiceRequest.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegenerationTextResultDto>;
    })
  );
}

documentAiV2ControllerRegenerateChildAdolescentServiceRequest.PATH = '/api/document-ai-v2/child-adolescent-service-request-ai/regenerate';
